module.exports = __webpack_public_path__ + "static/media/011-web-payment.068576e0.svg";